var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "study-line-dialog",
          attrs: {
            visible: _vm.showDialog,
            width: "30%",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("img", {
            staticClass: "line-icon",
            attrs: {
              src: require("../../common/img/study_line_icon.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "head-container",
            attrs: { slot: "title" },
            slot: "title"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "line-title" }, [
            _vm._v(_vm._s(_vm.$lang.call_notification))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "middle-container" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$lang.study_call_tips.replace(
                    "%template%",
                    _vm.liveInfo.teacherName
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom-btns" },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.isBtnLoading },
                  on: { click: _vm.onCancel }
                },
                [_vm._v(_vm._s(_vm.$lang.cancel_reservation))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "enter-btn",
                  attrs: { type: "primary", loading: _vm.isBtnLoading },
                  on: { click: _vm.toStudyLive }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$lang.enter_live) +
                      " (" +
                      _vm._s(_vm.seconds) +
                      "s)"
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24095d9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24095d9f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Public/StudyLineTips.vue
// module id = null
// module chunks = 